import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BatchJobRecipient, BatchStatus, BatchType, MessageTransaction } from './types';
import axiosInstance from '../../axios/axiosInstance';
import { fnRenderSmsPreview, fnRenderWhatsAppPreview, getStatusColor, getStatusText } from './render-utils';
import { Tooltip } from '../../components/tooltip/tooltip';
// import { messageTransactionService, MessageTransaction, MessageRecipient } from '../services/messageTransaction';

export interface MessageRecipient {
  id: string;
  name: string;
  phoneNumber: string;
  status: 'pending' | 'sent' | 'delivered' | 'failed';
  channels: {
    whatsapp?: MessageChannel;
    sms?: MessageChannel;
  };
}

export default function MessageTransactionDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [transaction, setTransaction] = useState<MessageTransaction | null>(null);
  const [loading, setLoading] = useState(true);
  const [selectedRecipients, setSelectedRecipients] = useState<number[]>([]);

  useEffect(() => {
    const loadTransaction = () => {
      if (!id) return;
      // const transaction = messageTransactionService.getTransaction(id);
      axiosInstance.get(`/api/batch-jobs/${id}`).then(d => {

        console.log((d.data as any).data)
        setTransaction((d.data as any).data as MessageTransaction);
        setLoading(false);
      }).catch(e => {
        setLoading(false)
      })

    };

    loadTransaction();
    const interval = setInterval(loadTransaction, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval);
  }, [id]);

  const handleRetry = (recipientId: number, channel: 'whatsapp' | 'sms') => {
    if (!id) return;
    // messageTransactionService.retryRecipient(id, recipientId, channel);
    alert("not implemented")
  };

  const handleResend = (recipientId: number, channel: 'whatsapp' | 'sms') => {
    if (!id) return;
    // messageTransactionService.resendToRecipient(id, recipientId, channel);
    alert("not implemented")
  };

  const handleBulkRetry = () => {
    if (!id || !transaction) return;
    selectedRecipients.forEach(recipientId => {
      const recipient = transaction.recipients.find(r => r.id === recipientId);
      if (recipient) {
        Object.keys(recipient.channels).forEach(channel => {
          if (channel === 'whatsapp' || channel === 'sms') {
            handleRetry(recipientId, channel);
          }
        });
      }
    });
    setSelectedRecipients([]);
  };

  const handleBulkResend = () => {
    if (!id || !transaction) return;
    selectedRecipients.forEach(recipientId => {
      const recipient = transaction.recipients.find(r => r.id === recipientId);
      if (recipient) {
        Object.keys(recipient.channels).forEach(channel => {
          if (channel === 'whatsapp' || channel === 'sms') {
            handleResend(recipientId, channel);
          }
        });
      }
    });
    setSelectedRecipients([]);
  };

  const toggleRecipientSelection = (recipientId: number) => {
    setSelectedRecipients(prev =>
      prev.includes(recipientId)
        ? prev.filter(id => id !== recipientId)
        : [...prev, recipientId]
    );
  };

  // const getStatusColor = (status: BatchStatus) => {
  //   switch (status) {
  //     case BatchStatus.delivered:
  //       return 'text-green-600 dark:text-green-400';
  //     case BatchStatus.failed:
  //       return 'text-red-600 dark:text-red-400';
  //     case BatchStatus.sent:
  //       return 'text-blue-600 dark:text-blue-400';
  //     default:
  //       return 'text-neutral-600 dark:text-neutral-400';
  //   }
  // };

  const formatDate = (date?: Date) => {
    if (!date) return '-';
    return new Date(date).toLocaleString();
  };

  let renderWhatsAppPreview: Function
  if (transaction && transaction.batchType == BatchType.GROUP)
    renderWhatsAppPreview = fnRenderWhatsAppPreview(transaction!.template, transaction!.message.whatsapp_message.header_parameters, transaction!.message.whatsapp_message.body_parameters);
  else
    renderWhatsAppPreview = () => <></>
    
  let renderSmsPreview: Function
  if (transaction && transaction.batchType == BatchType.GROUP)
    renderSmsPreview = fnRenderSmsPreview(transaction!.template, transaction!.message.whatsapp_message.body_parameters, transaction!.message.sms_message.text);
  else
    renderSmsPreview = () => <></>

  const renderConfirmationModal = () => {

    return (
      <div>

        {renderWhatsAppPreview()}
        {renderSmsPreview()}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex justify-center items-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-neutral-800 dark:border-white"></div>
      </div>
    );
  }

  if (!transaction) {
    return (
      <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 flex justify-center items-center">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-neutral-900 dark:text-white mb-4">
            Transaction Not Found
          </h1>
          <button
            onClick={() => navigate('/messages')}
            className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
          >
            Back to Messages
          </button>
        </div>
      </div>
    );
  }



  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900">
      <div className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold mb-4 dark:text-white">Channels</h2>
              {transaction.message.channels?.sms ? <span title="SMS user" className="ml-2"><i className="fa-solid fa-sms text-blue-500"></i></span> : null}
              {transaction.message.channels?.whatsapp ? <span title="WhatsApp user" className="ml-1"><i className="fa-brands fa-whatsapp text-green-500"></i></span> : null}
            </div>

          </div>
        </div>
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="text-xl font-semibold mb-4 dark:text-white">Message</h2>
              <p className="text-neutral-600 dark:text-neutral-400">
                Template: {transaction.templateName}
              </p>
            </div>
            <button
              onClick={() => navigate('/message-transactions')}
              className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300"
            >
              Back to Messages
            </button>
          </div>
        </div>


        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2">
            <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg p-6 mb-8">
              {transaction != null && transaction.batchType == BatchType.GROUP ? renderConfirmationModal() : null}
            </div>

            <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg overflow-hidden">
              <div className="p-6 border-b dark:border-neutral-700">
                <div className="flex items-center justify-between">
                  <h2 className="text-xl font-semibold dark:text-white">Recipients</h2>
                  {selectedRecipients.length > 0 && (
                    <div className="flex space-x-2">
                      <button
                        onClick={handleBulkRetry}
                        className="btn-primary"
                      >
                        Retry Selected
                      </button>
                      <button
                        onClick={handleBulkResend}
                        className="btn-success"
                      >
                        Resend Selected
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="bg-neutral-100 dark:bg-neutral-700">
                      <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                        <input
                          type="checkbox"
                          checked={selectedRecipients.length === transaction.recipients.length}
                          onChange={() => {
                            if (selectedRecipients.length === transaction.recipients.length) {
                              setSelectedRecipients([]);
                            } else {
                              setSelectedRecipients(transaction.recipients.map(r => r.id));
                            }
                          }}
                          className="rounded border-neutral-300 dark:border-neutral-600"
                        />
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                        Recipient Name
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                        Recipient Phone
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                        Status
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-center text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                        SMS/WHATSAPP
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-neutral-200 dark:divide-neutral-700">
                    {transaction.batchRecipients.map((recipient) => (
                      <tr key={recipient.id}>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <input
                            type="checkbox"
                            checked={selectedRecipients.includes(recipient.id)}
                            onChange={() => toggleRecipientSelection(recipient.id)}
                            className="rounded border-neutral-300 dark:border-neutral-600"
                          />
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-neutral-900 dark:text-white">
                            {recipient.member.name}
                          </div>
                          {/* <div className="text-sm text-neutral-500 dark:text-neutral-400">
                            {recipient.phoneNumber}
                          </div> */}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <div className="text-sm font-medium text-neutral-900 dark:text-white">
                            {recipient.phoneNumber}
                          </div>
                          {/* <div className="text-sm text-neutral-500 dark:text-neutral-400">
                            {recipient.phoneNumber}
                          </div> */}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap">
                          <span className={`text-sm font-medium ${getStatusColor(recipient.status)}`}>
                            {recipient.status == BatchStatus.failed ? <Tooltip content={recipient.error_message || ""} >
                              {getStatusText(recipient.status)}
                            </Tooltip> : getStatusText(recipient.status)}
                          </span>
                        </td>

                        <td className="px-6 py-4  text-center  whitespace-nowrap">
                          <span className={`text-sm font-medium ${getStatusColor(recipient.status)}`}>
                            {recipient.isWhatsapp ? <span title="WhatsApp user" className="ml-1"><i className="fa-brands fa-whatsapp text-green-500"></i></span>
                              : <span title="SMS user" className="ml-1"><i className="fa-solid fa-sms text-blue-500"></i></span>}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-lg p-6">
              <h2 className="text-xl font-semibold mb-4 dark:text-white">Transaction Details</h2>
              <div className="space-y-4">
                <div>
                  <h3 className="text-sm font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Status
                  </h3>
                  <p className={`text-lg font-medium ${getStatusColor(transaction.status)}`}>
                    {/* {transaction.status.charAt(0).toUpperCase() + transaction.status.slice(1)} */}
                    {getStatusText(transaction.status)}
                  </p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Progress
                  </h3>
                  <div className="flex items-center">
                    <div className="w-full bg-neutral-200 dark:bg-neutral-700 rounded-full h-2 mr-2">
                      <div
                        className="bg-blue-600 h-2 rounded-full"
                        style={{ width: `${transaction.progress}%` }}
                      ></div>
                    </div>
                    <span className="text-sm text-neutral-600 dark:text-neutral-400">
                      {Math.round(transaction.progress)}%
                    </span>
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Recipients
                  </h3>
                  <p className="text-neutral-900 dark:text-white">
                    {transaction.successfulRecipients} / {transaction.totalRecipients} sent
                  </p>
                  {/* {transaction.failedRecipients > 0 && (
                    <p className="text-red-600 dark:text-red-400">
                      {transaction.failedRecipients} failed
                    </p>
                  )} */}
                </div>
                {/* <div>
                  <h3 className="text-sm font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Channels
                  </h3>
                  <div className="flex space-x-2">
                    {transaction.channels.map((channel) => (
                      <span
                        key={channel}
                        className="px-2 py-1 text-xs font-medium rounded-full bg-neutral-100 dark:bg-neutral-700 text-neutral-800 dark:text-neutral-200"
                      >
                        {channel.toUpperCase()}
                      </span>
                    ))}
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Created At
                  </h3>
                  <p className="text-neutral-900 dark:text-white">
                    {formatDate(transaction.createdAt)}
                  </p>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-neutral-500 dark:text-neutral-400 mb-1">
                    Last Updated
                  </h3>
                  <p className="text-neutral-900 dark:text-white">
                    {formatDate(transaction.updatedAt)}
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 